import React from 'react';
import Quality from '../components/Quality';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import PreviewBadge from '../components/PreviewBadge';
import RedirectToPBL from '../components/RedirectToPBL';
import MetaHeader from '../components/MetaHeader';
import { I18n } from 'react-polyglot';
import LiveChatTracking from './LiveChatTracking';

class App extends React.Component {
  state = {
    is_preview: true,
    loading: true,
    published: false,
    publishing: false,
    language: '',
    translations: {}
  };

  token = new URLSearchParams(window.location.hash.substring(1)).get(
    'access_token'
  );

  get authHeaders() {
    return this.token ? { Authorization: `Bearer ${this.token}` } : {};
  }

  constructor() {
    super();

    this.handlePublish = this.handlePublish.bind(this);

    if (this.token) {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );
    }
  }

  async componentDidMount() {
    try {
      const { license, group } = this.props;

      const data = await fetch(
        `/api/${license}${group ? `/${group}` : ''}`,
        { headers: this.authHeaders }
      );
      const license_data = await data.json();

      if (!license_data.language) {
        this.setState({ error: true });
        return;
      }

      const lang = await fetch(`/api/languages/${license_data.language}`);
      const translations = await lang.json();

      this.setState({
        license,
        ...license_data,
        translations,
        loading: false
      });
    } catch (e) {
      this.setState({ error: true });
    }
  }

  async handlePublish() {
    const { license, group } = this.props;

    this.setState({ publishing: true });

    const publish = await fetch(
      `/api/${license}${group ? `/${group}` : ''}/enable`,
      {
        method: 'POST',
        headers: this.authHeaders
      }
    );

    if (publish.ok) {
      this.setState({ published: true, publishing: false });
      window.history.pushState(
        'Quality page',
        'Quality page',
        `/${license}${group ? `/${group}` : ''}`
      );
      setTimeout(() => this.setState({ is_preview: false }), 2000);
      return true;
    }

    this.setState({ publishing: false });
  }

  render() {
    if (this.state.error || this.state.errors) {
      return <RedirectToPBL {...this.state} license={this.state.license} />;
    }

    const { translations, language } = this.state;

    return (
      <I18n locale={language} messages={translations}>
        <div>
          <MetaHeader {...this.state} />
          <PreviewBadge handlePublish={this.handlePublish} state={this.state} />

          {this.state.loading
            ? <Loader />
            : <div>
              <Quality {...this.state} {...this.props} />
              <Footer {...this.state} />
            </div>}
        </div>
      </I18n>
    );
  }
}

export default LiveChatTracking(App);
